(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", function(e) {
  if (e.target.classList.contains("blog-load-more")) {
    e.preventDefault();
    let btn = e.target;
    let url = btn.dataset.nextUrl;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, "text/html");
        let newArticles = doc.querySelectorAll(".blog-card");

        let grid = document.querySelector(".blog-grid");
        newArticles.forEach(article => grid.appendChild(article));

        let newBtn = doc.querySelector(".blog-load-more");
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        } else {
          btn.remove();
        }
      });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
